module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4",
    class: {
      'has-error': _vm.showTextDangerUnidade
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerUnidade
    }
  }, [_vm._v("Unidade")]), _vm._v(" "), _c('select-unidade', {
    attrs: {
      "show-text-danger-unidade": _vm.showTextDangerUnidade,
      "nomeUnidade": _vm.dados.unidade.nome
    },
    on: {
      "setUnidadeSelecionada": function (unidadeSelecionada) {
        _vm.setUnidadeSelecionada(unidadeSelecionada);
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2",
    class: {
      'has-error': _vm.showTextDangerTipoPessoa
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerTipoPessoa
    }
  }, [_vm._v("Tipo de pessoa")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.tipo_pessoa),
      expression: "dados.tipo_pessoa"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "tipo_pessoa", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Física")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Jurídica")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2",
    class: {
      'has-error': _vm.showTextDangerTipo
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerTipo
    }
  }, [_vm._v("Tipo de Contrato")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.tipo),
      expression: "dados.tipo"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "tipo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Solicitante")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Prestador")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2",
    class: {
      'has-error': _vm.showTextDangerDataInicial
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerDataInicial
    }
  }, [_vm._v("Data Inicial")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.data_inicial),
      expression: "dados.data_inicial"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.dados.data_inicial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "data_inicial", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2",
    class: {
      'has-error': _vm.showTextDangerDataFinal
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerDataFinal
    }
  }, [_vm._v("Data Final")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.data_final),
      expression: "dados.data_final"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.dados.data_final)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "data_final", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3",
    class: {
      'has-error': _vm.showTextDangerLimiteGeral
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerLimiteGeral
    }
  }, [_vm._v("Limite Geral (R$)")]), _vm._v(" "), _c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: (_vm.dados.limite_geral),
      callback: function($$v) {
        _vm.$set(_vm.dados, "limite_geral", $$v)
      },
      expression: "dados.limite_geral"
    }
  }, 'money', _vm.money, false))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    class: {
      'has-error': _vm.showTextDangerLimiteCancelamento
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerLimiteCancelamento
    }
  }, [_vm._v("Limite de Cancelamentos")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.limite_cancelamento),
      expression: "dados.limite_cancelamento"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.dados.limite_cancelamento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "limite_cancelamento", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    class: {
      'has-error': _vm.showTextDangerLimiteRegulacao
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerLimiteRegulacao
    }
  }, [_vm._v("Limite de Regulações")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.limite_regulacao),
      expression: "dados.limite_regulacao"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.dados.limite_regulacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "limite_regulacao", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.showTextDangerSituacao
    }
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerSituacao
    }
  }, [_vm._v("Situação")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.situacao),
      expression: "dados.situacao"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "situacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Ativo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Inativo")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.salvar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Salvar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default pull-left",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" Cancelar")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Novo Contrato")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-af8e36bc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/distribuicoes/contratos/form.vue
// module id = 894
// module chunks = 0